<div *ngIf="visible" class="pl-infobox p-3" [ngClass]="type">
  <mat-icon *ngIf="iconName" class="circle mr-3"> {{ iconName }} </mat-icon>
  <ng-content></ng-content>
  {{ message }}
  <button mat-icon-button *ngIf="canClose" (click)="close()">
    <mat-icon> close </mat-icon>
  </button>
</div>
